import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';

function getDismissedPresentationStorageKey(householdId: string) {
  return `${LOCAL_STORAGE_KEYS.SMART_REVIEW_PRESENTATION_BANNER_DISMISSED}-${householdId}`;
}

export function getDismissedSmartReviewPresentationId(householdId: string) {
  return localStorage.getItem(getDismissedPresentationStorageKey(householdId));
}

export function dismissSmartReviewPresentation(
  householdId: string,
  presentationId: string
) {
  localStorage.setItem(
    getDismissedPresentationStorageKey(householdId),
    presentationId
  );
}
